import { type UseQueryResult, useQuery } from 'react-query';
import {
  ProfileService,
  type Volo_Abp_Account_ProfileDto,
} from '../../services/wealthlane-identity-services';

const useGetMyProfile = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<Volo_Abp_Account_ProfileDto | undefined, unknown> => {
  const myProfile = useQuery(['getMyProfile'], async () => {
    return await handleRequest(ProfileService.getApiIdentityApiAccountMyProfile());
  });
  return myProfile;
};

export default useGetMyProfile;
